var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovementSavusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 -2 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.3125 30 30 23.3125 30 15C30 6.68745 23.3125 0 15 0C6.68745 0 0 6.68745 0 15C0 23.3125 6.68745 30 15 30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99189 29.5 0.5 23.0081 0.5 15C0.5 6.99189 6.99189 0.5 15 0.5C23.0081 0.5 29.5 6.99189 29.5 15Z",
    fill: "white",
    stroke: "#3A14A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9983 9.54294L19.6416 14.1859H23.7475L14.9983 5.43689L6.24939 14.1859H10.3553L14.9983 9.54294Z",
    fill: "#3A14A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6415 15.9092L14.9982 20.5521L10.3552 15.9092H6.24939L14.9982 24.6582L23.7475 15.9092H19.6415Z",
    fill: "#3A14A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementSavusd);
export default __webpack_public_path__ + "static/media/movement-savusd.404b73dbb1a04dbda88d6ff7b8f553ff.svg";
export { ForwardRef as ReactComponent };